import { MonoTypeOperatorFunction } from 'rxjs';
import { shareReplay } from 'rxjs/operators';

export function shareReplayDestroyed<T>(bufferSize: number): MonoTypeOperatorFunction<T> {
  return input$ => input$.pipe(shareReplay({ bufferSize, refCount: true }));
}
